import {DefaultTheme} from 'react-native-paper';
import {colors} from './colors';

export const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: colors.primary,
    secondary: colors.secondary,
    background: colors.background,
    surface: colors.surface,
    error: colors.error,
    text: colors.text,
    onSurface: colors.text,
    outline: colors.border,
  },
  roundness: 8,
};

export {colors} from './colors';
export {spacing, borderRadius} from './spacing';
